import { render } from "./HeadingButtons.vue?vue&type=template&id=33ef6fc8"
import script from "./HeadingButtons.vue?vue&type=script&lang=js"
export * from "./HeadingButtons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__